import { Expo } from 'gsap/EasePack'
import TweenMax from 'gsap/TweenMax'
import App from '../App'

export default class QuoteForm {
  constructor() {

    this.bindMethods()
    this.getElems()
    this.events()
  }

  bindMethods() {
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
  }

  getElems() {
    this.el = document.querySelector('.quote')
    this.button = document.querySelector('.header__quote')
    this.closeButton = document.querySelector('.close-button')
    this.wrapper = document.querySelector('.quote-wrapper')
    this.innerWrapper = document.querySelector('.quote__form')
    this.formWrapper = this.innerWrapper.querySelector('.gform_wrapper')
  }

  events() {
    this.button.addEventListener('click', this.open)
    this.closeButton.addEventListener('click', this.close)
  }

  handleEnter() {
    if (!document.body.classList.contains('formsubmit-2')) return

    this.open()
    document.body.classList.remove('formsubmit-2')
  }

  open() {
    if (App.smoothScroll) App.smoothScroll.stop()
    TweenMax.to(this.wrapper, 1, {
      x: '0%',
      ease: Expo.easeOut
    })
    TweenMax.to(this.innerWrapper, 1, {
      x: '0%',
      ease: Expo.easeOut,
      onStart: () => {
        this.el.classList.add('open')
      }
    })
    if (this.formWrapper) {
      TweenMax.to(this.formWrapper, 1, {
        delay: 0.25,
        alpha: 1,
        ease: Expo.easeOut
      })
    }
  }

  close() {
    if (App.smoothScroll) App.smoothScroll.start()
    TweenMax.to(this.wrapper, 1, {
      x: '100%',
      ease: Expo.easeInOut
    })
    if (this.formWrapper) {
      TweenMax.to(this.formWrapper, 1, {
        delay: 0.2,
        alpha: 0,
        ease: Expo.easeOut
      })
    }
    TweenMax.to(this.innerWrapper, 1, {
      x: '-100%',
      ease: Expo.easeInOut,
      onStart: () => {
        this.el.classList.remove('open')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/util/QuoteForm.js